import clsx from "clsx";

// Components
import InputValue from "../InputValue";

// MUI
import { FormControl } from "@mui/material";
import { useGridApiContext } from "@mui/x-data-grid-premium";
import { NumberOrString } from "../InputValue/types";
import { TableInputValueProps, ValueInput } from "./types";

export default function TableInputValue(props: Readonly<TableInputValueProps>) {
	const apiRef = useGridApiContext();
	const {
		id,
		field,
		value,
		disabled,
		error,
		isControlledApi,
		isNaNPrevented,
		onActionUpdate,
		onChangeType,
	} = props;

	const handleUpdateInput = async (input: ValueInput, callback?: (val: NumberOrString, input: string) => void) => {
		if (isNaNPrevented && isNaN(Number(input.value))) {
			return;
		}

		callback?.(input.value, input.input);

		if (!isControlledApi && id && field) {
			// `debounceMs` is important to avoid the input to be updated too often.
			await apiRef.current.setEditCellValue({ id, field, value: input, debounceMs: 200 });
			// Stop editing mode manually ("auto-stop")
			apiRef.current.stopCellEditMode({ id, field });
		}
	};

	return (
		<FormControl fullWidth>
			<InputValue
				{...props}
				defaultType={value?.input ?? "Unit"}
				value={value?.value}
				variant={clsx({
					error,
					disabled: !error && disabled,
					default: !error && !disabled,
				})}
				classes={"table-input-value"}
				onActionUpdate={(val, input) => handleUpdateInput({ value: val, input }, onActionUpdate)}
				onChangeType={(val, input) => handleUpdateInput({ value: val, input }, onChangeType)}
			/>
		</FormControl>
	);
}
